import { render, staticRenderFns } from "./FlowLoader.vue?vue&type=template&id=876e6bd4&scoped=true&"
import script from "./FlowLoader.vue?vue&type=script&lang=js&"
export * from "./FlowLoader.vue?vue&type=script&lang=js&"
import style0 from "./FlowLoader.vue?vue&type=style&index=0&id=876e6bd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "876e6bd4",
  null
  
)

export default component.exports